import { defineMessages } from 'react-intl'

export default defineMessages({
  finalizeSchedulingPoll: {
    id: 'containers.SchedulingPollFinalizeModal.finalizeSchedulingPoll',
    defaultMessage: 'Finalize Scheduling Poll',
  },
  selectFinalTimeSlot: {
    id: 'containers.SchedulingPollFinalizeModal.selectFinalTimeSlot',
    defaultMessage: 'Select Final Time Slot *',
  },
  available: {
    id: 'containers.SchedulingPollFinalizeModal.available',
    defaultMessage: 'available',
  },
  maybe: {
    id: 'containers.SchedulingPollFinalizeModal.maybe',
    defaultMessage: 'maybe',
  },
  unavailable: {
    id: 'containers.SchedulingPollFinalizeModal.unavailable',
    defaultMessage: 'unavailable',
  },
  sendEmailNotification: {
    id: 'containers.SchedulingPollFinalizeModal.sendEmailNotification',
    defaultMessage: 'Send email notification to all participants ({count, plural, one {# person} other {# people}})',
  },
  customEmailMessage: {
    id: 'containers.SchedulingPollFinalizeModal.customEmailMessage',
    defaultMessage: 'Custom Email Message (Optional)',
  },
  customEmailPlaceholder: {
    id: 'containers.SchedulingPollFinalizeModal.customEmailPlaceholder',
    defaultMessage: 'Add a personal message to include in the notification email...',
  },
  timeSlotAutoIncluded: {
    id: 'containers.SchedulingPollFinalizeModal.timeSlotAutoIncluded',
    defaultMessage: 'The selected time slot details will be automatically included in the email.',
  },
  aboutToFinalize: {
    id: 'containers.SchedulingPollFinalizeModal.aboutToFinalize',
    defaultMessage: 'You are about to finalize this meeting time:',
  },
  finalizing: {
    id: 'containers.SchedulingPollFinalizeModal.finalizing',
    defaultMessage: 'Finalizing...',
  },
  finalizeSend: {
    id: 'containers.SchedulingPollFinalizeModal.finalizeSend',
    defaultMessage: 'Finalize & Send',
  },
  selectTimeSlotError: {
    id: 'containers.SchedulingPollFinalizeModal.selectTimeSlotError',
    defaultMessage: 'Please select a time slot',
  },
  pollFinalizedSuccess: {
    id: 'containers.SchedulingPollFinalizeModal.pollFinalizedSuccess',
    defaultMessage: 'Scheduling poll finalized!',
  },
  finalizePollError: {
    id: 'containers.SchedulingPollFinalizeModal.finalizePollError',
    defaultMessage: 'Failed to finalize poll',
  },
})
